import { t } from '../ui/lang';
// Shared bits for the DuoPlus ("duo") farm UI — used by the post-create config modal
// (farm-modals.ts) and the Duo Setup settings tab (duo-setup-tab.ts).
/**
 * Public IP of the panel/clicker host that must be allowed in DuoPlus so ADB
 * connections from here are accepted. Add it in the DuoPlus console under the ADB
 * connection IP whitelist. Kept here as the single source of truth.
 */
export const DUO_ADB_WHITELIST_IP = '63.184.174.158';
/**
 * Setup steps for a duo farm (no modal chrome), shared by the config modal and the
 * Duo Setup tab. English-only, matching the panel's tone.
 */
export function duoSetupStepsHtml() {
    return `
        <p class="modal__text">${t('farmdev.duo_step1')}</p>
        <p class="modal__text" style="margin-top:10px">${t('farmdev.duo_step2')}</p>
        <p class="modal__text" style="margin-top:10px">${t('farmdev.duo_step3')}</p>
        <p class="modal__text" style="margin-top:10px">${t('farmdev.duo_step4')}</p>
        <div class="launch-block">
            <pre class="launch-pre">${DUO_ADB_WHITELIST_IP}</pre>
            <button class="tbl-btn copy-key-btn" data-copy-duo-ip title="${t('common.copy')}">⎘ ${t('common.copy')}</button>
        </div>
        <p class="modal__text" style="margin-top:6px;font-size:0.85em;opacity:0.7">
            ${t('farmdev.duo_whitelist_note')}
        </p>
    `;
}
/** Wire the "Copy" button rendered by {@link duoSetupStepsHtml}. */
export function wireDuoSetup(root) {
    root.querySelector('[data-copy-duo-ip]')?.addEventListener('click', (e) => {
        const btn = e.currentTarget;
        void navigator.clipboard.writeText(DUO_ADB_WHITELIST_IP);
        btn.textContent = `✓ ${t('common.copied')}`;
        setTimeout(() => { btn.textContent = `⎘ ${t('common.copy')}`; }, 1500);
    });
}
